import { ConvertedImage, ConvertedImageRaw } from '../../types';

import { ChallengeSaveError } from '../../../types';

import { createCoreMethod } from '../../utils/createCoreMethod';
import { getImageForNode } from '../../utils/getImageForNode';
import { isNodeWithSize } from '../../utils/isNodeWithSize';
import { isNodeWithChildren } from '../../utils/isNodeWithChildren';

export const getVariantNodeImageFromTempLayer = createCoreMethod(
  'getVariantNodeImageFromTempLayer',
  async (
    variantNames: string[]
  ): Promise<
    ChallengeSaveError | (ConvertedImageRaw | ChallengeSaveError)[]
  > => {
    await figma.currentPage.loadAsync();

    let parentNode: SceneNode | null | undefined =
      figma.currentPage.children[figma.currentPage.children.length - 1];

    if (!parentNode || parentNode.name !== 'velocity-temp-data') {
      parentNode = figma.currentPage.children.find(
        (node) => node.name === 'velocity-temp-data'
      );
    }

    if (!parentNode) {
      return { type: 'NODE_NOT_FOUND' };
    }

    if (!isNodeWithChildren(parentNode)) return { type: 'NODE_NOT_FOUND' };

    const byName = new Map<string, SceneNode>();

    for (const node of parentNode.children) {
      byName.set(node.name, node);
    }

    const results: (ConvertedImage | ChallengeSaveError)[] = [];

    for (const variantName of variantNames) {
      const node: BaseNode | null = byName.get(variantName) || null;

      if (!node || !isNodeWithSize(node)) {
        return { type: 'NODE_NOT_FOUND' };
      }

      try {
        node.visible = true;
        if ('opacity' in node) node.opacity = 1;
        const result = await getImageForNode(node, true);
        node.remove();
        results.push(result);
      } catch {
        return { type: 'NODE_NOT_FOUND', nodeId: node.id, nodeName: node.name };
      }
    }

    return results.map((r) => {
      if ('converted' in r) {
        return {
          converted: r.converted.take(),
        };
      }

      return r;
    });
  }
);
